// Invoke 'strict' JavaScript mode
'use strict';
module.exports = require('./src/urlshortner');


//////////////////
// WEBPACK FOOTER
// ./node_modules/node-url-shortener/index.js
// module id = 433
// module chunks = 0